import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import ScrollToTopButton from '@/components/feature/ScrollToTopButton';
import SectionHeading from '@/components/feature/SectionHeading';
import MovieCard from '@/components/feature/MovieCard';
import HeroCarousel from './components/HeroCarousel';
import CategoryEntries from './components/CategoryEntries';
import HotRanking from './components/HotRanking';
import TopicSections from './components/TopicSections';
import { movies } from '@/mocks/content';
import type { ContentItem } from '@/types/content';

export default function Home() {
  const allItems = movies as ContentItem[];

  const featured = allItems.filter((item) => item.featured).slice(0, 4);
  const latest = [...allItems]
    .sort((a, b) => (a.updatedAt < b.updatedAt ? 1 : -1))
    .slice(0, 10);
  const hot = [...allItems].sort((a, b) => b.views - a.views).slice(0, 8);
  const weeklySeries = allItems.filter((item) => item.type === '电视剧').slice(0, 5);
  const classicMovies = allItems.filter((item) => item.type === '电影').slice(0, 5);
  const hotVariety = allItems.filter((item) => item.type === '综艺').slice(0, 5);

  return (
    <div className="min-h-screen w-full bg-background-100 flex flex-col">
      <SiteHeader />

      <main className="w-full flex-1">
        <HeroCarousel items={featured} />

        <section className="w-full px-4 md:px-8 py-8 md:py-10">
          <SectionHeading
            title="分类快捷入口"
            subtitle="按类型快速进入，发现更多精彩内容"
          />
          <CategoryEntries />
        </section>

        <section className="w-full px-4 md:px-8 py-8 md:py-10 bg-background-50">
          <SectionHeading
            title="最新影视"
            subtitle="刚刚上线与持续更新的优质内容"
            morePath="/category/电影"
          />
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-5">
            {latest.map((item) => (
              <MovieCard key={item.id} item={item} />
            ))}
          </div>
        </section>

        <section className="w-full px-4 md:px-8 py-8 md:py-10">
          <SectionHeading
            title="热门影视推荐"
            subtitle="基于播放热度与近期更新的精选榜单"
            morePath="/search"
            moreLabel="去搜索"
          />
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
            <div className="lg:col-span-2">
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 md:gap-5">
                {hot.slice(0, 6).map((item) => (
                  <MovieCard key={item.id} item={item} />
                ))}
              </div>
            </div>
            <div className="lg:col-span-1">
              <div className="flex items-center gap-2 mb-3">
                <i className="ri-bar-chart-box-line text-accent-500 text-lg" />
                <h3 className="font-heading font-semibold text-base text-foreground-950">
                  播放热度榜
                </h3>
              </div>
              <HotRanking items={hot} />
            </div>
          </div>
        </section>

        <TopicSections
          weeklySeries={weeklySeries}
          classicMovies={classicMovies}
          hotVariety={hotVariety}
        />

        <section className="w-full px-4 md:px-8 py-8 md:py-12 bg-primary-50">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">
              关于 91大神影视大全
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              91大神汇聚电影、电视剧与综艺栏目等丰富影视内容，覆盖多种类型与题材。我们以清晰的分类、便捷的搜索与筛选，帮助每一位影迷在最短时间内找到想看的作品，让浏览与查询影视资源变得轻松愉快。
            </p>
            <div className="mt-6 flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-sm text-foreground-600">
              <span className="flex items-center gap-2">
                <i className="ri-film-line text-accent-500 text-lg" />
                海量影视资源
              </span>
              <span className="flex items-center gap-2">
                <i className="ri-search-eye-line text-accent-500 text-lg" />
                精准搜索筛选
              </span>
              <span className="flex items-center gap-2">
                <i className="ri-refresh-line text-accent-500 text-lg" />
                每日持续更新
              </span>
            </div>
          </div>
        </section>
      </main>

      <SiteFooter />
      <ScrollToTopButton />
    </div>
  );
}